var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.69,53.39A.84.84,0,0,0,71.6,53a63.28,63.28,0,0,0-3-13.61,8.38,8.38,0,0,0-7.88-5.35h-5.2V29.69a.85.85,0,0,0-1.7,0V51.05A2.94,2.94,0,0,1,50.91,54H.85a.85.85,0,0,0-.85.85v5.32a4.41,4.41,0,0,0,4.41,4.41h6a.85.85,0,1,0,0-1.7h-6A2.71,2.71,0,0,1,1.7,60.16V55.69H50.91a4.64,4.64,0,0,0,4.63-4.63V35.76h5.2A6.76,6.76,0,0,1,67,40a61.17,61.17,0,0,1,2.82,12.55h-9.1a.85.85,0,1,0,0,1.7H70c.18,2,.29,3.93.29,5.87v2.76H65.64a6,6,0,1,0,.78,1.7h4.73a.85.85,0,0,0,.85-.85V60.11a65.2,65.2,0,0,0-.35-6.55A.81.81,0,0,0,71.69,53.39ZM60.77,70.3a4.17,4.17,0,1,1,4.17-4.17A4.18,4.18,0,0,1,60.77,70.3Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36,66.13A5.87,5.87,0,1,0,30.14,72,5.88,5.88,0,0,0,36,66.13Zm-10,0a4.17,4.17,0,1,1,4.17,4.17A4.18,4.18,0,0,1,26,66.13Z",
    fill: "#e30613"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.61,
    cy: 66.13,
    r: 1.41,
    fill: "#e30613"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.14,
    cy: 66.13,
    r: 1.41,
    fill: "#e30613"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.74,
    cy: 66.13,
    r: 1.41,
    fill: "#e30613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7,63.11a.85.85,0,0,0,0-1.2,5.87,5.87,0,1,0,0,8.44.85.85,0,0,0-1.18-1.22,4.17,4.17,0,1,1,0-6A.85.85,0,0,0,23.7,63.11Z",
    fill: "#e30613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52,64.56a.85.85,0,0,0,0-1.7H38.81a.85.85,0,1,0,0,1.7Z",
    fill: "#e30613"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41,51H48.5a2.41,2.41,0,0,0,2.41-2.41V17.86a2.41,2.41,0,0,0-2.41-2.41H2.41A2.41,2.41,0,0,0,0,17.86V48.58A2.41,2.41,0,0,0,2.41,51ZM1.7,17.86a.71.71,0,0,1,.71-.71H48.5a.71.71,0,0,1,.71.71V48.58a.71.71,0,0,1-.71.71H2.41a.71.71,0,0,1-.71-.71Z",
    fill: "#e30613"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12,30.6A.85.85,0,0,0,7,29.75V22.42H14.3a.85.85,0,0,0,0-1.7H6.12a.85.85,0,0,0-.85.85v8.18A.85.85,0,0,0,6.12,30.6Z",
    fill: "#e30613"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.28,
    cy: 22.6,
    r: 1.3,
    fill: "#e30613"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.28,
    cy: 29.68,
    r: 1.3,
    fill: "#e30613"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.28,
    cy: 36.76,
    r: 1.3,
    fill: "#e30613"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.28,
    cy: 43.84,
    r: 1.3,
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokTransport);
export default __webpack_public_path__ + "static/media/hok-transport.88f28700a7f0ce289af888c831071e98.svg";
export { ForwardRef as ReactComponent };